:host {
  .hide {
    display: none !important;
  }

  .no-margin-bottom {
    margin-bottom: 0 !important;
    border-color: #e91e63 !important;
    border-color: var(--red) !important;
  }

  .required-field {
    display: block;
    color: #e91e63;
    color: var(--red);
    margin-bottom: 10px;
    font-size: 11px;
    margin-left: 5px;
    margin-top: 2px;
  }

  .tooltip {
    position: relative;
  }

  .tooltip .tooltiptext {
    visibility: hidden;
    width: 100px;
    background-color: #fff;
    background-color: var(--bg-tooltip);
    color: #333333;
    color: var(--font-primary);
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    opacity: 0;
    transition: opacity 0.3s;
    padding: 10px;
    box-shadow: 0 0 10px 0 rgba(51, 51, 51, 0.15);
    margin-left: 0;
    left: 50%;
    transform: translateX(-50%);
    font-size: 11px;
    line-height: 14px;
  }

  .tooltip .tooltiptext::after {
    content: '';
    position: absolute;
    top: 100%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #fff transparent transparent transparent;
    border-color: var(--bg-tooltip) transparent transparent transparent;
    right: 50%;
    transform: translateX(50%);
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }

  .margin-bottom-50 {
    margin-bottom: 50px !important;
  }

  .support-ik {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    img {
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
    span {
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      color: var(--font-primary);
    }

    &--full {
      span {
        color: white;
      }
    }
  }

  .mail-product {
    background: white;
    background: var(--bg-primary);
    border-radius: 10px;
    padding: 24px;

    .ticket-title {
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      color: var(--font-primary);
      margin-bottom: 18px;
    }

    .input-subject,
    .input-os,
    .input-app-version {
      //margin-bottom: 50px;
      &.not-last-input {
        //margin-bottom: 10px;
      }
    }

    select,
    input,
    textarea {
      box-sizing: border-box;
      width: 100%;
      border: 1px solid #e0e0e0;
      border: 1px solid var(--divider);
      border-radius: 4px;
      padding: 15px;
      font-size: 15px;
      color: #666;
      color: var(--font-secondary);
      margin-bottom: 18px;
      font-family: Roboto, sans-serif;
      background: #fff;
      background: var(--bg-primary);

      &:focus {
        outline: none;
      }
    }

    select {
      -moz-appearance: none;
      -webkit-appearance: none;
      appearance: none;
      background-image: url('data:image/svg+xml;base64,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');
      background-repeat: no-repeat, repeat;
      background-position:
        right 0.7em top 50%,
        0 0;
      background-size:
        12px auto,
        100%;
      cursor: pointer;
    }

    textarea {
      min-height: 150px;
      resize: none;

      &::placeholder,
      &:-ms-input-placeholder,
      &::-ms-input-placeholder {
        opacity: 1; /* Firefox */
        color: #666;
        color: var(--font-secondary);
      }
    }

    input {
      color: #333;
      color: var(--font-primary);

      &::placeholder {
        color: #666;
        color: var(--font-secondary);
        opacity: 1; /* Firefox */
      }

      &:-ms-input-placeholder,
      &::-ms-input-placeholder {
        color: #666;
        color: var(--font-secondary);
      }
    }

    .need-information {
      display: flex;
      border-radius: 10px;
      padding: 15px;
      background-color: #f4f6fd;
      background-color: var(--bg-blue-manager);
      color: #333333;
      color: var(--font-primary);
      box-sizing: border-box;
      margin-bottom: 18px;

      &__text {
        font-size: 13px;
        text-align: justify;

        a {
          text-decoration: none;
          color: var(--blue-link, #0098ff);
        }
      }

      &__image {
        margin-right: 10px;
        img {
          width: 16px;
          height: 16px;
        }

        @media (max-width: 768px) {
          margin-bottom: 20px;
        }
      }
    }

    .mail-product-files {
      &__title {
        color: #333333;
        color: var(--font-primary);
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 21px;
      }

      &__description {
        color: #666666;
        color: var(--font-secondary);
        font-size: 12px;
        letter-spacing: 0;
        line-height: 14px;
        margin-bottom: 20px;
      }

      &__files {
        .file-container {
          position: relative;
          display: flex;
          border: 2px dashed #e0e0e0;
          border: 2px dashed var(--divider);
          padding: 15px 60px 15px 15px;
          margin-bottom: 20px;
          height: 100%;
          flex-wrap: wrap;

          img {
            width: 18px;
            height: 18px;
            object-fit: contain;
            margin-right: 20px;
            filter: invert(9%) sepia(5%) saturate(560%) hue-rotate(201deg) brightness(92%)
              contrast(94%);
            filter: var(--icon-bg-primary--invert);
          }

          a {
            text-decoration: none;
            color: #0098ff;
            color: var(--blue);
          }

          .file {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            width: calc(20% - 10px);
            text-align: center;
            margin-right: 5px;
            margin-left: 5px;
            margin-bottom: 10px;
            margin-top: 10px;
            box-sizing: border-box;

            img {
              width: 22px;
              height: 22px;
              margin-right: 0;
              margin-bottom: 5px;
            }

            &__close {
              display: flex;
              align-items: center;
              justify-content: center;
              position: absolute;
              right: 0;
              top: -10px;

              img {
                cursor: pointer;
                position: relative;
                width: 12px;
                height: 12px;
                margin: 0;
                object-fit: contain;
                filter: invert(19%) sepia(16%) saturate(0%) hue-rotate(157deg) brightness(94%)
                  contrast(95%);
                filter: var(--icon-font-primary);
              }
            }

            &__title {
              color: #333333;
              color: var(--font-primary);
              font-size: 12px;
              letter-spacing: 0;
              line-height: 16px;
              text-overflow: ellipsis;
              width: 80px;
              white-space: nowrap;
              overflow: hidden;
            }
          }

          .upload {
            background: #0098ff;
            background: var(--blue);
            width: 36px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            color: var(--font-primary--invert);
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            border-radius: 4px;
            cursor: pointer;

            &:hover {
              transition: background 0.3s;
              background: #007ee2;
              background: var(--blue-hover);
            }
          }
        }

        &--hover {
          .file-container {
            border-color: #0098ff;
            border-color: var(--blue);
          }
        }
      }

      &__info {
        display: flex;
        border-radius: 4px;
        background-color: #f4f6fd;
        background-color: var(--bg-blue-manager);
        color: #333;
        color: var(--font-primary);
        padding: 15px;
        box-sizing: border-box;
        margin-bottom: 18px;

        img {
          width: 16px;
          height: 16px;
          object-fit: contain;
          margin-right: 10px;
          filter: invert(54%) sepia(44%) saturate(7155%) hue-rotate(183deg) brightness(102%)
            contrast(109%);
          filter: var(--icon-blue);
        }

        p {
          margin: 0;
        }
      }
    }

    .question {
      margin-bottom: 18px;
      padding: 15px 20px;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      background-color: #fff;
      background-color: var(--bg-primary);

      &.required {
        border-color: #e91e63;
        border-color: var(--red);
      }

      &__title {
        color: #666666;
        color: var(--font-secondary);
        font-size: 15px;
        letter-spacing: 0;
        line-height: 24px;
      }

      &__choice {
        margin-top: 15px;

        button {
          background-color: #fff;
          background-color: var(--bg-primary);
          color: #0098ff;
          color: var(--blue);
          padding: 15px;
          border-radius: 4px;
          border: 1px solid #0098ff;
          cursor: pointer;
          width: 100%;
          max-width: 166px;
          margin-right: 10px;
          margin-bottom: 10px;

          &:focus {
            outline: none;
          }

          &:hover,
          &.selected {
            transition: background 0.3s;
            background-color: #0098ff;
            background-color: var(--blue);
            color: white;
          }

          &.disabled {
            opacity: 0.5;

            &:hover {
              background-color: #0098ff;
              background-color: var(--blue);
              color: white;
            }
          }

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }

    .mail-product-action {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .g-recaptcha {
        margin-bottom: 20px;
      }

      button {
        width: 100%;
        background-color: #0098ff;
        background-color: var(--blue);
        color: white;
        padding: 14px;
        border-radius: 4px;
        border: none;
        cursor: pointer;

        &:focus {
          outline: none;
        }

        &:hover {
          transition: background 0.3s;
          background: #007ee2;
          background: var(--blue-hover);
        }

        &.disabled {
          opacity: 0.5;

          &:hover {
            background-color: #0098ff;
            background-color: var(--blue);
            color: white;
          }
        }
      }
    }
    &--error,
    &--success {
      height: 100%;
    }

    /* -------------------------------------------------------------------------- */
    /*                                FULL VERSION                                */
    /* -------------------------------------------------------------------------- */

    &.mail-product--full {
      background: white;
      background: var(--bg-primary);
      padding: 30px;
      box-sizing: border-box;
      border-radius: 6px;

      .first-row {
        display: flex;
        justify-content: center;

        .select-service {
          margin-right: 10px;

          &.margin-right-0 {
            margin-right: 0;
          }
        }

        .select-sub-service {
          margin-right: 0;
        }
      }
    }

    /* -------------------------------------------------------------------------- */
    /*                           SCROLL IN FULL VERSION                           */
    /* -------------------------------------------------------------------------- */
    &.mail-product--scroll {
      textarea,
      .input-subject {
        margin-bottom: 20px;
      }
    }
  }

  .mail-priority {
    display: none;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 20px;
    font-weight: 500;

    &.display {
      display: flex;
    }

    &__text {
      margin-bottom: 10px;
      display: flex;
      align-items: center;

      .tooltip {
        margin-left: 10px;

        .tooltiptext {
          font-size: 12px;
          width: 250px;
        }
      }

      img {
        filter: invert(42%) sepia(0%) saturate(1920%) hue-rotate(236deg) brightness(95%)
          contrast(98%);
        filter: var(--icon-font-secondary);
      }
    }

    &__buttons {
      button {
        background-color: white;
        background-color: var(--bg-primary);
        color: #0098ff;
        padding: 10px 30px;
        border-radius: 4px;
        border: none;
        cursor: pointer;
        margin: 0 5px;
        border: 1px solid #0098ff;

        &.selected {
          background: #0098ff;
          background: var(--blue);
          color: white;
        }

        &:focus {
          outline: none;
        }

        &:hover {
          transition: background 0.3s;
          background: #0098ff;
          background: var(--blue);
          color: white;
        }
      }
    }

    .mail-priority-warning {
      display: flex;
      background: white;
      background: var(--bg-primary);
      padding: 15px;
      box-sizing: border-box;
      margin-top: 20px;
      border-radius: 4px;
      color: #333;
      color: var(--font-primary);

      &__checkbox {
        input {
          width: 18px;
          height: 18px;
          display: block;
          margin-right: 10px;
        }
      }

      strong {
        font-weight: 500;
      }
    }
  }

  .ending-padding {
    height: 24px;
  }

  .error {
    display: block;
    margin-bottom: 20px;
    color: #fb472e;
    color: var(--danger);

    .error-file {
      display: block;
      margin-bottom: 5px;

      strong {
        font-weight: 500;
      }
    }
  }

  select:disabled,
  input:disabled,
  textarea:disabled {
    opacity: 0.6;
  }
}
